export default __webpack_public_path__ + "static/media/509.960d7124.jpg";